"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeIsLiteStore = exports.finishShopifyConnection = exports.fetchShopifyUrlValidity = exports.FetchShopifyUrlValidity = exports.FetchShopifyUrlValidityActionTypes = exports.ShopifyConnectionActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var ShopifyConnectionActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_URL_VALIDITY: null,
  FINISH_SHOPIFY_CONNECTION: null,
  CHANGE_IS_LITE_STORE: null
}, 'shopify-connection');
exports.ShopifyConnectionActionTypes = ShopifyConnectionActionTypes;
var FetchShopifyUrlValidityActionTypes = (0, _actions.createRequestTypes)(ShopifyConnectionActionTypes.FETCH_URL_VALIDITY);
exports.FetchShopifyUrlValidityActionTypes = FetchShopifyUrlValidityActionTypes;
var FetchShopifyUrlValidity = (0, _actions.createRequestActions)(FetchShopifyUrlValidityActionTypes);
exports.FetchShopifyUrlValidity = FetchShopifyUrlValidity;
var fetchShopifyUrlValidity = (0, _createAction.default)(ShopifyConnectionActionTypes.FETCH_URL_VALIDITY, function (storeName) {
  return storeName;
});
exports.fetchShopifyUrlValidity = fetchShopifyUrlValidity;
var finishShopifyConnection = (0, _createAction.default)(ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION);
exports.finishShopifyConnection = finishShopifyConnection;
var changeIsLiteStore = (0, _createAction.default)(ShopifyConnectionActionTypes.CHANGE_IS_LITE_STORE, function (isLite) {
  return isLite;
});
exports.changeIsLiteStore = changeIsLiteStore;